import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Envelope';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25V18.75C21 19.1642 20.6642 19.5 20.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25ZM4.5 6V6.36808L12 11.8226L19.5 6.36808V6H4.5ZM19.5 8.22283L12.4411 13.3566C12.1781 13.5478 11.8219 13.5478 11.5589 13.3566L4.5 8.22283V18H19.5V8.22283Z" fill="currentColor"/>
  </svg>
`;

const EnvelopeIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25V18.75C21 19.1642 20.6642 19.5 20.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25ZM4.5 6V6.36808L12 11.8226L19.5 6.36808V6H4.5ZM19.5 8.22283L12.4411 13.3566C12.1781 13.5478 11.8219 13.5478 11.5589 13.3566L4.5 8.22283V18H19.5V8.22283Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: EnvelopeIcon,
  IconSvg: IconSvg
} as IconType;
